// Static content for Harbour Haze Cafe Bar — real menus & logo supplied by owner.

export const IMAGES = {
  logo: "https://static.prod-images.emergentagent.com/jobs/41ef6973-b134-455c-8c5c-d52993bb9c42/images/39f354b639bbf73455089d09de371f7fd90781e5ba3807ffb0d3b75453e7fe70.png",
  logoFull: "/harbour-haze-logo.png?v=2",
  hero: "/hero-sunset.webp?v=1",
  pub: "https://images.pexels.com/photos/32675839/pexels-photo-32675839.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  jetty: "https://images.pexels.com/photos/33361799/pexels-photo-33361799.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  beer: "https://images.pexels.com/photos/6570266/pexels-photo-6570266.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  plate: "https://images.unsplash.com/photo-1599118732532-f1cdb1ae7389?w=900&q=80",
  chicken: "https://images.unsplash.com/photo-1627858034922-72a657d6b3c2?w=900&q=80",
  pizza: "https://images.unsplash.com/photo-1621538997517-58ce53933faa?w=900&q=80",
  breakfast: "https://images.pexels.com/photos/29177412/pexels-photo-29177412.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  cocktail: "https://images.pexels.com/photos/34440645/pexels-photo-34440645.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  van: "https://images.pexels.com/photos/20993514/pexels-photo-20993514.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};

export const PUB = {
  name: "Harbour Haze",
  tagline: "Cafe Bar",
  address: "2i Waipapa Avenue, Diamond Harbour",
  region: "Whakaraupō / Lyttelton Harbour, Aotearoa NZ",
};

// tags: V = vegan, VO = vegan option, GFO = gluten free option
export const FOOD = {
  Breakfast: {
    note: "Served until 11:30am",
    img: "breakfast",
    items: [
      { name: "Full Harbour", price: "28", desc: "Locally sourced sausage, bacon, hash brown, beans, mushrooms, seared tomato, toast and eggs your way" },
      { name: "Vegan Harbour", price: "28", tags: ["V"], desc: "Vegan sausage, hash brown, beans, mushrooms, seared tomato, toast and scrambled tofu" },
      { name: "Eggs Benedict", price: "24", desc: "Homemade hash, spinach, 2 poached eggs, hollandaise with your choice of mushroom or bacon" },
      { name: "Scrambled Tofu on Toast", price: "22", tags: ["V", "GFO"], desc: "Sourdough toast, tomato relish, well seasoned scramble tofu" },
      { name: "Eggs on Toast", price: "15", tags: ["GFO"], desc: "Sourdough toast, butter, eggs your way" },
      { name: "Muesli", price: "15", tags: ["VO"], desc: "Muesli, milk and fresh seasonal fruit" },
      { name: "Bacon or Sausage Buttie", price: "15", tags: ["VO"], desc: "Sourdough, butter, bacon or sausage, your choice of tomato or HP sauce" },
      { name: "Beans on Toast", price: "12", tags: ["V", "GFO"], desc: "Sourdough toast, butter, beans" },
      { name: "Any Side", price: "4", desc: "Egg, beans, mushrooms, bacon, toast, sausage, tomato or hash brown" },
    ],
  },
  "Small Plates": {
    img: "plate",
    items: [
      { name: "Calamari", price: "16", desc: "Locally sourced calamari, served with lemon aioli" },
      { name: "Karaage Fried Chicken", price: "16", desc: "Japanese soy / egg marinade chicken" },
      { name: "Karaage Fried Cauliflower", price: "16", tags: ["V"], desc: "In a Japanese soy marinade" },
      { name: "Vegetable Dumplings", price: "18", tags: ["VO"], desc: "Served with a sweet chilli dip" },
      { name: "Chips or Wedges", price: "10", tags: ["VO", "GFO"], desc: "Add cheese & gravy +$4 · curry sauce +$4 · cheese & bacon +$5 · cheese +$3. Vegan cheese available" },
    ],
  },
  Mains: {
    img: "chicken",
    items: [
      { name: "Beer Battered Fish & Chips", price: "25", desc: "Locally sourced fish, handcut chips, served with slaw and tartar sauce" },
      { name: "Harbour Burger", price: "25", tags: ["VO", "GFO"], desc: "Beef smash patty, fried chicken or vegan patty on a brioche bun with fried onions, cheese, lettuce, sour cream and BBQ sauce, handcut chips" },
      { name: "Curry of the Day", price: "25", tags: ["VO"], desc: "Choice of marinated chicken, lamb, tofu or roast vegetables, served with rice and roti. Ask staff for today's options" },
    ],
  },
  Pizzas: {
    note: "All served with Italian marinara",
    img: "pizza",
    items: [
      { name: "Classic Cheese", price: "22", tags: ["GFO"], desc: "Cheese, marinara sauce, olive oil" },
      { name: "Pepperoni", price: "24", desc: "Cheese, pepperoni, red onion, marinara sauce, olive oil" },
      { name: "Vegan Sausage", price: "24", tags: ["V"], desc: "Vegan sausage, vegan cheese, onion, capsicum" },
      { name: "Mushroom For More", price: "22", tags: ["VO", "GFO"], desc: "Mushrooms, onion, cheese, herbs and garlic oil" },
      { name: "Chicken, Cranberry & Brie", price: "26", tags: ["GFO"], desc: "Chicken, brie, cheese, cranberry sauce" },
    ],
  },
};

export const DRINKS = {
  img: "beer",
  groups: [
    { title: "On Tap", items: ["Wayfarer Pilsner", "Murphys", "Heineken Silver Lager", "Monteiths Hazy WCIPA", "Guest Tap IPA / APA"] },
    { title: "Wine — Oyster Bay", items: ["Rosé", "Sav", "Chardonnay", "Pinot Gris", "Pinot Noir", "Merlot", "Sparkling Brut"] },
    { title: "Low / Zero Alcohol", items: ["Cassels Light Owl 2.5%", "Heineken 0%", "Giesen 0% Sav / Rosé"] },
    { title: "Cocktails · $16", items: ["Whisky Sour", "Old Fashioned", "Margarita", "Bloody Mary", "Cosmopolitan"] },
    { title: "Coffees", note: "Small $4 · Medium $5 · Large $6 — almond, soy, coconut, oat · syrups: vanilla, caramel, hazelnut", items: ["Flat White", "Latte", "Cappuccino", "Americano", "Long Black", "Mochaccino", "Hot Chocolate", "Selection of Teas"] },
  ],
  footnote: "Soft drinks available in the fridge.",
};

export const STORY = [
  {
    n: "01",
    title: "Just up the hill from the ferry",
    body: "Step off the Diamond Harbour ferry, wander up the hill, and you'll find us — a warm, sunny cafe bar looking back across Whakaraupō. Salt air, cold beer, honest food.",
  },
  {
    n: "02",
    title: "Book your table, we'll hold your spot",
    body: "Tell us how many, the day, and the ferry you're arriving on. Every booking comes straight to us to approve — if a table's tight, we'll call or email you first.",
  },
  {
    n: "03",
    title: "The Haze Van will fetch you",
    body: "That hill is a hill. Reserve a seat in our van at the jetty and we'll run you up to the door. Pick your seat like you're boarding — first in, best dressed.",
  },
];

export const SEAT_LABELS = {
  F1: "Front",
  M1: "Mid L", M2: "Mid C", M3: "Mid R",
  B1: "Back L", B2: "Back C", B3: "Back R",
};
